import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Menu, Icon} from 'semantic-ui-react';

class TablePaginator extends Component {
  render() {
    const {itemsCount, itemsPerPage, selectedPage, onOptionClick} = this.props;
    const pagesCount = Math.ceil(itemsCount / itemsPerPage);
    return (
      <Menu pagination>
        <Menu.Item
          as='a'
          icon
          onClick={onOptionClick.bind(this, 0)}
          disabled={selectedPage === 0}
        >
          <Icon name='angle double left' />
        </Menu.Item>
        <Menu.Item
          as='a'
          icon
          onClick={onOptionClick.bind(this, selectedPage - 1)}
          disabled={selectedPage === 0}
        >
          <Icon name='angle left' />
        </Menu.Item>
        {this.renderOptions(pagesCount, selectedPage)}
        <Menu.Item
          as='a'
          icon
          onClick={onOptionClick.bind(this, selectedPage + 1)}
          disabled={selectedPage === (pagesCount - 1)}
        >
          <Icon name='angle right' />
        </Menu.Item>
        <Menu.Item
          as='a'
          icon
          onClick={onOptionClick.bind(this, pagesCount - 1)}
          disabled={selectedPage === (pagesCount - 1)}
        >
          <Icon name='angle double right' />
        </Menu.Item>
      </Menu>
    );
  }

  renderOptions(pagesCount, selectedPage) {
    let options = [];
    if (pagesCount < 5) {
      options = [...options, this.renderAllPages(pagesCount, selectedPage)];
      return options;
    }
    if (selectedPage < 4) {
      options = [...options, this.renderLeftPages(selectedPage)];
      return options;
    }
    if (selectedPage > pagesCount - 5) {
      options = [...options, this.renderRightPages(pagesCount, selectedPage)];
      return options;
    }
    options = [...options, this.renderMiddlePages(selectedPage)];
    return options;
  }

  renderAllPages(pagesCount, selectedPage) {
    const {onOptionClick} = this.props;
    let pages = [];
    for (let i = 0; i < pagesCount; i++) {
      pages = [
        ...pages,
        (<Menu.Item
          key={i}
          as='a'
          onClick={onOptionClick.bind(this, i)}
          active={selectedPage === i}
        >
          {i + 1}
        </Menu.Item>),
      ];
    }
    return pages;
  }

  renderLeftPages(selectedPage) {
    const {onOptionClick} = this.props;
    let pages = [];
    for (let i = 0; i < 5; i++) {
      pages = [
        ...pages,
        (<Menu.Item
          key={i}
          as='a'
          onClick={onOptionClick.bind(this, i)}
          active={i === selectedPage}
        >
          {i + 1}
        </Menu.Item>),
      ];
    }
    return [
      ...pages,
      (<Menu.Item key={'left'} as='a' disabled>
        {'...'}
      </Menu.Item>),
    ];
  }

  renderRightPages(pagesCount, selectedPage) {
    const {onOptionClick} = this.props;
    let pages = [];
    pages = [
      ...pages,
      (<Menu.Item key={'right'} as='a' disabled>
        {'...'}
      </Menu.Item>),
    ];
    for (let i = pagesCount - 5; i < pagesCount; i++) {
      pages = [
        ...pages,
        (<Menu.Item
          key={i}
          as='a'
          onClick={onOptionClick.bind(this, i)}
          active={i === selectedPage}
        >
          {i + 1}
        </Menu.Item>),
      ];
    }
    return pages;
  }

  renderMiddlePages(selectedPage) {
    const {onOptionClick} = this.props;
    let pages = [];
    pages = [
      ...pages,
      (<Menu.Item key={'right'} as='a' disabled>
        {'...'}
      </Menu.Item>),
    ];
    for (let i = selectedPage - 1; i <= selectedPage + 1; i++) {
      pages = [
        ...pages,
        (<Menu.Item
          key={i}
          as='a'
          onClick={onOptionClick.bind(this, i)}
          active={i === selectedPage}
        >
          {i + 1}
        </Menu.Item>),
      ];
    }
    return [
      ...pages,
      (<Menu.Item key={'left'} as='a' disabled>
        {'...'}
      </Menu.Item>),
    ];
  }
}

TablePaginator.propTypes = {
  'itemsCount': PropTypes.number.isRequired,
  'itemsPerPage': PropTypes.number.isRequired,
  'selectedPage': PropTypes.number.isRequired,
  'onOptionClick': PropTypes.func.isRequired,
};

export default TablePaginator;
